import { adaptBuilderConnection } from './builder-connection-adapter'

export const makeBuilderComponentAdapter = ({
  schema,
  mediaUtils,
}) => (builderComponent) => ({
  connection: adaptBuilderConnection(builderComponent.connectionConfig, builderComponent.role, schema),
  setProps: (props) => {
    for (const [path, value] of Object.entries(props)) {
      const [prop, subprop] = path.split('.')
      if (subprop === undefined) {
        builderComponent[prop] = prop === 'link' ? convertLink(value, mediaUtils) : value
      } else {
        builderComponent[prop][subprop] = value
      }
    }
  },
  bind: () => {},
})

const convertLink = (value, mediaUtils) => {
  if (!value) {
    return ''
  }

  try {
    return mediaUtils.convertToUrl(value)
  } catch {
    return value
  }
}
